import * as React from "react";

import CloseIcon from "@impero-com/common/img/close-icon.svg";
import { assertNever } from "@impero-com/common/utils/obj";
import { Button, Svg } from "@impero-com/ui";
import { Drawer as AntDrawer, Spin, Typography } from "antd";

import * as theme from "./theme.css";

const { Text } = Typography;

const LARGE_WIDTH_IN_PX = 670;
const DEFAULT_WIDTH_IN_PX = 460;

class Drawer extends React.PureComponent<DrawerDialogProps> {
    render = () => {
        const { width: selectedWidth, maskClosable, busy } = this.props;
        let width: number;
        switch (selectedWidth) {
            case "LARGE":
                width = LARGE_WIDTH_IN_PX;
                break;
            case "DEFAULT":
            case undefined:
                width = DEFAULT_WIDTH_IN_PX;
                break;
            default:
                return assertNever(selectedWidth);
        }
        return (
            <AntDrawer
                closable={false}
                open={this.props.open ?? true}
                onClose={this.handleOnCancel}
                className={theme.drawerWrapper}
                width={width}
                maskClosable={maskClosable ?? true}
            >
                <Spin
                    spinning={busy ?? false}
                    wrapperClassName={theme.spinFullHeight}
                    className={theme.spinNoMaxHeight}
                >
                    <div className={theme.drawerContent}>
                        <div className={theme.header}>
                            {this.props.buildHeader &&
                                this.buildHeaderBasedOnItsSpecs(
                                    this.props.buildHeader
                                )}
                            {this.buildCloseButton()}
                        </div>
                        <div className={theme.content}>
                            {this.props.children}
                        </div>
                        {this.props.buildFooter && this.props.buildFooter() && (
                            <div id="drawer-footer" className={theme.footer}>
                                {this.props.buildFooter()}
                            </div>
                        )}
                    </div>
                </Spin>
            </AntDrawer>
        );
    };

    buildHeaderBasedOnItsSpecs = (buildHeader: () => React.ReactNode) => {
        const receivedHeader = buildHeader();
        if (typeof receivedHeader === "string") {
            return <Text className={theme.headerTitle}>{receivedHeader}</Text>;
        }

        return receivedHeader;
    };

    buildCloseButton = () => {
        return (
            <Button
                id={"close-button"}
                variant="link"
                onClick={this.handleOnCancel}
                className={theme.closeButton}
            >
                <Svg src={CloseIcon} className={theme.closeIcon} />
            </Button>
        );
    };

    handleOnCancel = () => {
        this.props.onCancel();
    };
}

interface DrawerDialogProps {
    onCancel: () => void;
    buildHeader?: () => React.ReactNode;
    buildFooter?: () => React.ReactNode;
    width?: "DEFAULT" | "LARGE";
    children?: React.ReactNode;
    maskClosable?: boolean;
    busy?: boolean;
    open?: boolean;
}

export { Drawer };
